import React, { useEffect } from "react";
import { notification } from "antd";
import { useSelector } from "react-redux";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

const ToastMessage = ({ type }) => {
  const [api, contextHolder] = notification.useNotification();

  const { toastMessage } = useSelector((state) => state.appState);

  const openNotificationWithIcon = (type, bgColor, border, width) => {
    let icon;
    if (type === "success")
      icon = <CheckCircleOutlined style={{ color: "#36C861" }} />;
    if (type === "info")
      icon = <InfoCircleOutlined style={{ color: "#1890FF" }} />;
    if (type === "warning")
      icon = <ExclamationCircleOutlined style={{ color: "#FAAD14" }} />;
    if (type === "error")
      icon = <CloseCircleOutlined style={{ color: "#FF4D4F" }} />;
    api[type]({
      // message: toastMessage.title,
      // description: toastMessage.description,
      message: toastMessage.titleFontSize ? (
        <span style={{ fontSize: toastMessage.titleFontSize }}>
          {toastMessage.title}
        </span>
      ) : (
        toastMessage.title
      ),
      description: toastMessage.descriptionFontSize ? (
        <span style={{ fontSize: toastMessage.descriptionFontSize }}>
          {toastMessage.description}
        </span>
      ) : (
        toastMessage.description
      ),
      icon,
      duration: toastMessage?.duration || 8,
      style: {
        backgroundColor: bgColor,
        border: `1px solid ${border}`,
        width: toastMessage.width,
      },
    });
  };
  useEffect(() => {
    if (toastMessage) {
      if (toastMessage.type == "success") {
        openNotificationWithIcon("success", "#F6FFED", "#B7EB8F");
      } else if (toastMessage.type == "error") {
        openNotificationWithIcon("error", "#FFF1F0", "#FFCCC7");
      } else if (toastMessage.type == "info") {
        openNotificationWithIcon("info", "#E6F7FF", "#91D5FF");
      }
    }
  }, [toastMessage]);

  return <>{contextHolder}</>;
};

export default ToastMessage;
